module.exports = __webpack_public_path__ + "0cb402ed92874d640ffaec4fc91edb11.svg";